import { RIGHT_PANE_VARIANTS } from '../../right-pane/constants';

import {
    CLOSE_RIGHT_PANE,
    OPEN_RIGHT_PANE
} from './types/right-pane-action-types';

export function closeRightPane(){
    return {
        type: CLOSE_RIGHT_PANE
    };
}

function openRightPane( activeRightPane, variant, title, subtitle, attributes = {} ){
    return {
        activeRightPane,
        attributes,
        subtitle,
        title,
        type: OPEN_RIGHT_PANE,
        variant,
    };
}

export function openSenderDetailsPane( senderId, senderName ){
    return openRightPane( 'senderDetails', RIGHT_PANE_VARIANTS['standard'], senderName, 'Sender details', { senderId } );
}

export function openUnverifiedSenderDetailsPane( senderId, senderName ){
    return openRightPane(
        'unverifiedSenderDetails',
        RIGHT_PANE_VARIANTS['standard'],
        senderName,
        'Identify if it\'s a legitimate sender of yours',
        { senderId }
    );
};

export function openDomainDetailsPane( domainName ){
    return openRightPane( 'domainDetails', RIGHT_PANE_VARIANTS['standard'], domainName, 'Domain details' );
}

export function openClaimedDomainDetailsPane( domainName ){
    return openRightPane( 'claimedDomainDetails', RIGHT_PANE_VARIANTS['standard'], domainName, 'Domain details' );
}

export function openDomainManagementBulkPane( domainActionType ){
    return openRightPane( 'domainManagementBulk', RIGHT_PANE_VARIANTS['modal'], 'Manage In Bulk', '', { domainActionType } );
}

export function openCanvasSettingsPane( { params } ){
    return openRightPane( 'canvasSettings', RIGHT_PANE_VARIANTS['floating'], 'Canvas Settings', '', { params } );
}
